import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Header from "@/components/organisms/common/Header.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { useRouter } from "vue-router";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import PointHistoryList from "@/components/organisms/mypage/PointHistoryList.vue";
import { accountService } from "@/app/services/AccountService";
import { ref, onBeforeMount } from "vue";
import { PointHistory } from "@/types/worker/PointHistory";

const QUERY_LIMIT = 100;

export default /*#__PURE__*/_defineComponent({
  __name: 'PointHistory',
  setup(__props) {

const { back } = useRouter();
const loader = useLoader();
const errorModal = useErrorModal();
const pointHistoryList = ref<PointHistory[]>([]);
const isFetching = ref<boolean>(false);
const isAllResultsFetched = ref<boolean>(false);

onBeforeMount(async () => {
  await fetchPointHistoryList();
});

const fetchPointHistoryList = async () => {
  if (isFetching.value || isAllResultsFetched.value) return;
  try {
    loader.show();
    isFetching.value = true;
    const query = {
      offset: pointHistoryList.value.length,
      limit: QUERY_LIMIT
    };
    const { results } = await accountService.fetchPointHistoryList(query);
    pointHistoryList.value = [...pointHistoryList.value, ...results];
    isAllResultsFetched.value = results.length < QUERY_LIMIT;
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    isFetching.value = false;
    loader.hide();
  }
};

const onClickBack = () => {
  back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      ポイント履歴\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(PointHistoryList, {
      pointHistoryList: pointHistoryList.value,
      onScrollToBottom: fetchPointHistoryList,
      class: "my-3"
    }, null, 8, ["pointHistoryList"])
  ]))
}
}

})